export default __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmWUlfChc4EsA.woff2";